import { inject, observer } from "mobx-react";
import AddUserComponent from "../../components/UserManagement/AddUser/AddUserComponent";

const AddUser = inject('userStore','sharedStore')(observer(AddUserComponent));

export default AddUser;